import React from "react";

export const PLANTING_SUPPLY_UNIT_HELP_TITLE =
  "Como o operador informa o abastecimento";

export function PlantingSupplyUnitHelpContent() {
  return (
    <>
      <p>
        Este campo não é a quantidade. Ele só define{" "}
        <strong>em que unidade</strong> o operador vai lançar o que entrou na
        caixa da plantadeira.
      </p>
      <p>Escolha uma destas opções:</p>
      <ul>
        <li>
          <strong>Sementes</strong> — número de sementes colocadas.
        </li>
        <li>
          <strong>Quilos</strong> — peso da semente, em kg.
        </li>
        <li>
          <strong>Sacas de semente</strong> — quantas sacas foram colocadas.
        </li>
        <li>
          <strong>Bag de semente</strong> — quantos bags foram colocados.
        </li>
      </ul>
      <p>
        No app, ao abastecer a plantadeira, o operador informa só o número —
        por exemplo, 2 bags ou 80 kg — nesta unidade.
      </p>
    </>
  );
}
